import { useMemo } from "react";

export interface AltusSourceSettingsText {
  unauthorisedWarningText: string;
  environmentLabelText: string;
  projectFilterLabelText: string;
  projectFilterPlaceholderText: string;
  projectFilterHintText: string;
  projectSearchPlaceholderText: string;
  bucketsToLoadLabelText: string;
  bucketsToLoadPlaceholderText: string;
  bucketsToLoadHintText: string;
  doneBucketLabelText: string;
  doneBucketPlaceholderText: string;
  doneBucketHintText: string;
  defaultBucketLabelText: string;
  defaultBucketPlaceholderText: string;
  defaultBucketHintText: string;
  assignedToMeLabelText: string;
  assignedToMeHintText: string;
  loadingBucketsText: string;
  searchingProjectsText: string;
  loadErrorText: string;
}

export const useAltusSourceSettingsText = (
  t: (key: string) => string,
): AltusSourceSettingsText => {
  return useMemo(() => {
    const tKey = (key: string): string =>
      t(`board.connections.dialog.sourceSettings.altus.${key}`);

    return {
      unauthorisedWarningText: tKey("unauthorisedWarning"),
      environmentLabelText: tKey("environmentLabel"),
      projectFilterLabelText: tKey("projectFilterLabel"),
      projectFilterPlaceholderText: tKey("projectFilterPlaceholder"),
      projectFilterHintText: tKey("projectFilterHint"),
      projectSearchPlaceholderText: tKey("projectSearchPlaceholder"),
      bucketsToLoadLabelText: tKey("bucketsToLoadLabel"),
      bucketsToLoadPlaceholderText: tKey("bucketsToLoadPlaceholder"),
      bucketsToLoadHintText: tKey("bucketsToLoadHint"),
      doneBucketLabelText: tKey("doneBucketLabel"),
      doneBucketPlaceholderText: tKey("doneBucketPlaceholder"),
      doneBucketHintText: tKey("doneBucketHint"),
      defaultBucketLabelText: tKey("defaultBucketLabel"),
      defaultBucketPlaceholderText: tKey("defaultBucketPlaceholder"),
      defaultBucketHintText: tKey("defaultBucketHint"),
      assignedToMeLabelText: tKey("assignedToMeLabel"),
      assignedToMeHintText: tKey("assignedToMeHint"),
      loadingBucketsText: tKey("loadingBuckets"),
      searchingProjectsText: tKey("searchingProjects"),
      loadErrorText: tKey("loadError"),
    };
  }, [t]);
};
